export default class rolesService{
	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
		this.routes = {
			"all": '/api/roles',
			"id": '/api/roles/:id',
			"new": '/api/roles',
			'delete': '/api/roles/:id',
            "update": '/api/roles',
		};
	}

	getAll(filter){
		let url = this.baseUrl + this.routes.all;
		let config = {
			params : filter
		};
		return this.http.get(url, config);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}

    update(data){
        let url = this.baseUrl + this.routes.new;
        return this.http.put(url, data);
    }

    delete(objId){
        let idRoute = this.routes.delete.replace(':id', objId._id);
        let url = this.baseUrl + idRoute;
        return this.http.delete(url);
    }
}



// WEBPACK FOOTER //
// ./app/js/services/rolesService.js